import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { ROUTES } from '../config/constants';
import PrivateRoute from '../components/auth/PrivateRoute';
import PublicRoute from '../components/auth/PublicRoute';
import TenantRoute from '../components/auth/TenantRoute';
import LoginPage from '../pages/Login/LoginPage';
import InitPasswordPage from '../pages/InitPassword/InitPasswordPage';
import ForgotPasswordPage from '../pages/ForgotPassword/ForgotPasswordPage';
import TenantSelectionPage from '../pages/TenantSelection/TenantSelectionPage';
import DashboardPage from '../pages/Dashboard/DashboardPage';
import TasksPage from '../pages/Tasks/TasksPage';
import ReportsPage from '../pages/Reports/ReportsPage';
import SettingsPage from '../pages/Settings/SettingsPage';
import RegulatorikPage from '../pages/Regulatorik/RegulatorikPage';
import NotFoundPage from '../pages/NotFound/NotFoundPage';
import SchutzbedarfsanalysePage from '../pages/Schutzbedarfsanalyse/SchutzbedarfsanalysePage';

const AppRoutes = () => {
    return (
        <Routes>
            {/* Public Routes */}
            <Route path="/login" element={
                <PublicRoute>
                    <LoginPage />
                </PublicRoute>
            } />

            <Route path="/init-password" element={
                <PublicRoute>
                    <InitPasswordPage />
                </PublicRoute>
            } />

            <Route path="/forgot-password" element={
                <PublicRoute>
                    <ForgotPasswordPage />
                </PublicRoute>
            } />

            {/* Private Routes (needs auth) */}
            <Route path="/tenant-selection" element={
                <PrivateRoute>
                    <TenantSelectionPage />
                </PrivateRoute>
            } />

            {/* Tenant Routes (needs auth + tenant) */}
            <Route path="/dashboard" element={
                <TenantRoute>
                    <DashboardPage />
                </TenantRoute>
            } />

            <Route path="/regulatorik/*" element={
                <TenantRoute>
                    <RegulatorikPage />
                </TenantRoute>
            } />

            <Route path="/tasks" element={
                <TenantRoute>
                    <TasksPage />
                </TenantRoute>
            } />

            <Route path="/reports" element={
                <TenantRoute>
                    <ReportsPage />
                </TenantRoute>
            } />

            <Route path="/settings" element={
                <TenantRoute>
                    <SettingsPage />
                </TenantRoute>
            } />

            {/* Schutzbedarfsanalyse Routes */}
            <Route
                path={ROUTES.SCHUTZBEDARFSANALYSE}
                element={
                    <TenantRoute>
                        <Navigate to={ROUTES.SCHUTZBEDARFSANALYSE_PROZESSE} replace />
                    </TenantRoute>
                }
            />
            <Route
                path={ROUTES.SCHUTZBEDARFSANALYSE_PROZESSE}
                element={
                    <TenantRoute>
                        <SchutzbedarfsanalysePage />
                    </TenantRoute>
                }
            />
            <Route
                path={ROUTES.SCHUTZBEDARFSANALYSE_ANWENDUNGEN}
                element={
                    <TenantRoute>
                        <SchutzbedarfsanalysePage />
                    </TenantRoute>
                }
            />
            <Route
                path={ROUTES.SCHUTZBEDARFSANALYSE_ANALYSEN}
                element={
                    <TenantRoute>
                        <SchutzbedarfsanalysePage />
                    </TenantRoute>
                }
            />
            <Route
                path={ROUTES.SCHUTZBEDARFSANALYSE_GAP_ANALYSEN}
                element={
                    <TenantRoute>
                        <SchutzbedarfsanalysePage />
                    </TenantRoute>
                }
            />
            <Route
                path={ROUTES.SCHUTZBEDARFSANALYSE_RISIKEN}
                element={
                    <TenantRoute>
                        <SchutzbedarfsanalysePage />
                    </TenantRoute>
                }
            />
            <Route
                path={ROUTES.SCHUTZBEDARFSANALYSE_MASSNAHMEN}
                element={
                    <TenantRoute>
                        <SchutzbedarfsanalysePage />
                    </TenantRoute>
                }
            />

            {/* Fallback Routes */}
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            <Route path="*" element={<NotFoundPage />} />
        </Routes>
    );
};

export default AppRoutes;
